module.exports = __webpack_public_path__ + "static/media/soccer-live.82f92ea6.svg";